module.exports = __webpack_public_path__ + "img/my-order.b99ec3c3.png";